export const GET_CLIENT_CHECKINS = 'checkIn/GET_CLIENT';
export const GET_CLIENT_CHECKINS_SUCCESS = 'checkIn/GET_CLIENT_SUCCESS';
export const GET_CLIENT_CHECKINS_ERROR = 'checkIn/GET_CLIENT_ERROR';

export const COMMENT_CHECKIN = 'checkIn/COMMENT';
export const COMMENT_CHECKIN_SUCCESS = 'checkIn/COMMENT_SUCCESS';
export const COMMENT_CHECKIN_ERROR = 'checkIn/COMMENT_ERROR';

// Mark a check-in reviewed without a comment (clears it from the trainer's
// review queue). Separate from COMMENT_CHECKIN so a bare review sends no
// client notification and leaves any existing comment untouched.
export const MARK_CHECKIN_REVIEWED = 'checkIn/MARK_REVIEWED';
export const MARK_CHECKIN_REVIEWED_SUCCESS = 'checkIn/MARK_REVIEWED_SUCCESS';
export const MARK_CHECKIN_REVIEWED_ERROR = 'checkIn/MARK_REVIEWED_ERROR';

export const GET_CURRENT_CHECKIN = 'checkIn/GET_CURRENT';
export const GET_CURRENT_CHECKIN_SUCCESS = 'checkIn/GET_CURRENT_SUCCESS';
export const GET_CURRENT_CHECKIN_ERROR = 'checkIn/GET_CURRENT_ERROR';

export const SUBMIT_CHECKIN = 'checkIn/SUBMIT';
export const SUBMIT_CHECKIN_SUCCESS = 'checkIn/SUBMIT_SUCCESS';
export const SUBMIT_CHECKIN_ERROR = 'checkIn/SUBMIT_ERROR';
export const RESET_SUBMIT_CHECKIN = 'checkIn/RESET_SUBMIT';

// Client-self history. Mirrors the mobile `/check-ins/me` flow so a
// web client can scroll their own past entries (ratings + photos +
// trainer comments) without going to the trainer-scoped endpoint.
export const GET_MY_CHECKINS = 'checkIn/GET_MY';
export const GET_MY_CHECKINS_SUCCESS = 'checkIn/GET_MY_SUCCESS';
export const GET_MY_CHECKINS_ERROR = 'checkIn/GET_MY_ERROR';
